import React, { useState } from 'react';
import { BASE, Box, Origem, Pager, Val, useGet } from './ui';

export function MatrizesTab() {
  const [pagina, setPagina] = useState(1);
  const [sel, setSel] = useState('');
  const d = useGet(`${BASE}/academico/matrizes`, { pagina });
  const m = useGet(sel ? `${BASE}/academico/matrizes/${encodeURIComponent(sel)}` : `${BASE}/status`);
  return (
    <Box testid="acervo-matrizes">
      <table className="w-full text-xs"><thead><tr className="text-left text-slate-500"><th>ID</th><th>Matriz (nome original)</th><th>RegimeID origem</th></tr></thead>
        <tbody>{(d?.items || []).map((x) => <tr key={x.legacy_id} onClick={() => setSel(x.legacy_id)} className="cursor-pointer border-t hover:bg-amber-50" data-testid={`acervo-matriz-${x.source_id}`}>
          <td>{x.source_id}</td><td>{x.campos_originais.Nome}</td><td><Val v={x.campos_originais.RegimeID} /></td></tr>)}</tbody></table>
      <Pager d={d} pagina={pagina} setPagina={setPagina} testid="acervo-matrizes-pager" />
      {sel && m?.matriz && (
        <div className="mt-3 border-t pt-2" data-testid="acervo-matriz-detalhe">
          <b>{m.matriz.campos_originais.Nome}</b> · {m.disciplinas.length} disciplinas · {m.cursos.length} cursos · {m.turmas.length} turmas
          <Origem o={m.matriz.origem} />
        </div>)}
    </Box>
  );
}

export function SistemasTab() {
  const d = useGet(`${BASE}/academico/sistemas-avaliacao`);
  return (
    <Box testid="acervo-sistemas">
      <p className="mb-2 text-xs text-slate-500">{d?.total ?? '…'} sistemas de avaliação da origem. Nenhuma nota é recalculada.</p>
      <table className="w-full text-xs"><thead><tr className="text-left text-slate-500"><th>ID</th><th>Nome</th><th>NomePeriodo</th><th>TipoAvaliacao</th><th>Config. de pontos</th></tr></thead>
        <tbody>{(d?.items || []).map((s) => <tr key={s.legacy_id} className="border-t"><td>{s.source_id}</td><td>{s.campos_originais.Nome}</td><td>{s.campos_originais.NomePeriodo}</td>
          <td><Val v={s.campos_originais.TipoAvaliacao} /></td><td>{s.config_pontos.length}</td></tr>)}</tbody></table>
    </Box>
  );
}

function Evidencia2026() {
  const d = useGet(`${BASE}/evidencia-2026`);
  return (
    <div className="mt-3 border-t pt-2 text-xs" data-testid="acervo-evidencia-2026">
      <b>Evidência Sponte 2026 (sem uso acadêmico): {d?.total ?? '…'} registros</b>
      <ul>{(d?.por_colecao || []).map((x) => <li key={x.colecao + x.motivo}>{x.colecao} · {x.motivo.replaceAll('_', ' ')} · {x.registros}</li>)}</ul>
    </div>
  );
}

export function PendenciasTab() {
  const [tipo, setTipo] = useState('');
  const [pagina, setPagina] = useState(1);
  const d = useGet(`${BASE}/academico/pendencias`, tipo ? { tipo, pagina } : { pagina });
  return (
    <Box testid="acervo-pendencias">
      <select className="mb-2 rounded border px-2 py-1 text-xs" value={tipo} onChange={(e) => { setTipo(e.target.value); setPagina(1); }} data-testid="acervo-pendencias-tipo">
        <option value="">Todas</option><option value="SEM_MATRIZ">Sem matriz</option><option value="NOME_ANOMALO">Nome anômalo</option>
      </select>
      <table className="w-full text-xs"><tbody>{(d?.items || []).map((t) => <tr key={t.legacy_id} className="border-t"><td className="py-1">{t.year_source}</td><td>{t.campos_originais.Nome}</td><td>{t.review_notes.join(' · ')}</td></tr>)}</tbody></table>
      <Pager d={d} pagina={pagina} setPagina={setPagina} testid="acervo-pendencias-pager" />
      <Evidencia2026 />
    </Box>
  );
}

export function CoberturaTab() {
  const d = useGet(`${BASE}/cobertura`);
  if (!d) return <Box>Carregando…</Box>;
  return (
    <Box testid="acervo-cobertura">
      <p className="text-sm"><b data-testid="acervo-cobertura-total">{d.total}</b> arquivos · {d.linhas.toLocaleString('pt-BR')} linhas · carregados <b>{d.carregados}</b> · pendentes <b data-testid="acervo-cobertura-pendentes">{d.pendentes}</b></p>
      <p className="mb-2 text-xs text-slate-500">Nenhum arquivo é abandonado: o que não foi carregado segue pendente, com o original preservado no ZIP fora do banco.</p>
      <div className="max-h-[480px] overflow-auto"><table className="w-full whitespace-nowrap text-xs"><thead className="sticky top-0 bg-white"><tr className="text-left text-slate-500"><th>#</th><th>Arquivo</th><th>SHA-256</th><th>Linhas</th><th>Destino previsto</th><th>Carga</th><th>Pendência</th><th>Acesso</th><th>Frio</th><th>Conciliação</th></tr></thead>
        <tbody>{d.items.map((r) => <tr key={r.n} className="border-t"><td>{r.n}</td><td>{r.arquivo}</td><td className="font-mono">{r.sha256.slice(0, 10)}…</td><td>{r.linhas}</td>
          <td>{r.destino_previsto}</td><td>{r.carga_efetiva}</td><td>{r.pendencia}</td><td>{r.acesso}</td><td>{r.historico_frio ? 'sim' : '—'}</td><td>{r.conciliacao}</td></tr>)}</tbody></table></div>
    </Box>
  );
}

export function LotesTab() {
  const d = useGet(`${BASE}/lotes`);
  const a = useGet(`${BASE}/auditoria`);
  return (
    <Box testid="acervo-lotes">
      <table className="w-full text-xs"><thead><tr className="text-left text-slate-500"><th>Lote</th><th>Tipo</th><th>Status</th><th>Início</th><th>Contagens</th></tr></thead>
        <tbody>{(d?.items || []).map((b) => <tr key={b._id} className="border-t"><td className="font-mono">{b._id.slice(0, 8)}</td><td>{b.kind}</td><td>{b.status}</td><td>{b.started_at?.slice(0, 19)}</td><td>{JSON.stringify(b.counts)}</td></tr>)}</tbody></table>
      <p className="mt-3 text-xs font-semibold">Trilha de auditoria</p>
      <ul className="text-xs" data-testid="acervo-auditoria">{(a?.items || []).slice(0, 40).map((x) => <li key={x._id}>{x.at?.slice(0, 19)} · {x.perfil || 'cli'} · {x.action} · {x.target}</li>)}</ul>
    </Box>
  );
}
